module.exports = __webpack_public_path__ + "img/sharks-logo-icon.5c4573e6.png";